import React, { useRef } from "react";
import Table from "react-bootstrap/Table";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// Import your images
const utahData = "/img/headerlogo.png";
const kpi = "/img/KPI-DASH 2.png";
const bodex = "/img/bodexLogo.png";
const pdf = "/img/pdf1.png";
// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const AeroTable4 = ({ apiData }) => {
  const pdfRef = useRef();

  const years = apiData.map((item) => item.year);
  const allSexesData = apiData.map((item) => item["All Sexes"]);
  const femaleData = apiData.map((item) => item["Female"]);
  const maleData = apiData.map((item) => item["Male"]);

  const chartData = {
    labels: years,
    datasets: [
      {
        label: "All Sexes Employment",
        data: allSexesData,
        backgroundColor: "rgba(75, 192, 192)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Female Employment",
        data: femaleData,
        backgroundColor: "rgba(170, 0, 0)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
      {
        label: "Male Employment",
        data: maleData,
        backgroundColor: "rgba(25, 25, 112)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
    },
    scales: {
      x: { title: { display: true, text: "Year" } },
      y: {
        title: { display: true, text: "Employment Count" },
        beginAtZero: true,
      },
    },
  };

  const downloadPDF = () => {
    const input = pdfRef.current;
    const originalWidth = input.style.width;
    input.style.width = "1200px"; // Ensure consistent rendering for PDF

    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 190; // Width for A4 size
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Header
      pdf.addImage(utahData, "PNG", 60, 10, 32, 16); // Logo
      pdf.setFontSize(26);
      pdf.text("UTahData.org", 95, 22);
      pdf.link(50, 15, 60, 10, { url: "https://utahdata.org" });

      pdf.setFontSize(12);
      pdf.setLineWidth(0.5);
      pdf.line(10, 35, 200, 35); // Line after header

      // Add the main content
      const headerHeight = 38;
      pdf.addImage(imgData, "PNG", 10, headerHeight, imgWidth, imgHeight);

      // Footer
      pdf.line(10, 260, 200, 260); // Line before footer
      const footerStartY = 265;
      pdf.addImage(utahData, "PNG", 22, 265, 30, 15);
      pdf.setFontSize(10);
      pdf.setTextColor(0, 122, 255);
      pdf.text("Built by", 55, footerStartY + 10);
      pdf.addImage(bodex, "PNG", 68, footerStartY + 4, 44, 10);
      pdf.text("using", 112, footerStartY + 10);
      pdf.addImage(kpi, "PNG", 125, footerStartY, 20, 20);
      pdf.text(" 20250916.v3.198", 148, footerStartY + 10);

      // Date and URL
      const currentDate = new Date().toLocaleDateString();
      pdf.setFontSize(10);
      pdf.text(`Downloaded on: ${currentDate}`, 150, 295);
      const currentURL = window.location.href;
      pdf.text(`Downloaded from: ${currentURL}`, 10, 295);

      // Save the PDF
      pdf.save("employment-trend-dashboard.pdf");
      input.style.width = originalWidth; // Reset to original width
    });
  };

  return (
    <div className="max-w-full mx-auto p-4">
      <div ref={pdfRef} className="content-to-export">
        <h2>Growth Rate by Gender</h2>
        {/* Table Section */}
        <div className="overflow-x-auto">
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Year</th>
                <th>All Sexes Employment</th>
                <th>Female Employment</th>
                <th>Male Employment</th>
                <th>Total Employment Growth %</th>
                <th>Female Growth %</th>
                <th>Male Growth %</th>
              </tr>
            </thead>
            <tbody>
              {apiData.map((data, index) => (
                <tr key={index}>
                  <td>{data.year}</td>
                  <td>{data["All Sexes"]}</td>
                  <td>{data["Female"]}</td>
                  <td>{data["Male"]}</td>
                  <td>{data["Total Employment Growth %"]}</td>
                  <td>{data["Women Growth %"]}</td>
                  <td>{data["Men Growth %"]}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <div
          style={{
            width: "90%",
            maxWidth: "800px",
            margin: "auto",
            overflowX: "auto",
          }}
        >
          {" "}
          <div
            style={{
              width: "100%", // Takes 100% width of the parent div, but will scroll if needed
              minWidth: "600px", // Ensures a minimum width, enabling scroll when the chart exceeds screen size
              height: "400px",
              background: "#fff",
            }}
          >
            <Bar data={chartData} options={chartOptions} />
          </div>
        </div>
      </div>

      {/* Download Button */}
      <div className="flex justify-center">
        <button
          onClick={downloadPDF}
          className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
        >
          <span>Download as PDF </span>
          <span>
            <img className="w-[2rem]" src={pdf} onClick={downloadPDF} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default AeroTable4;
